import {
  useEffect,
  useState,
  React,
} from 'react';
import {
  Edit3 as Edit3Icon,
  Lock,
  RefreshCcw,
  Trash2 as Trash2Icon,
  Unlock,
} from 'react-feather';
import moment from 'moment';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  useDispatch,
  useSelector,
} from 'react-redux';
import { SimsoAction } from 'src/actions/simso.action';
import {
  CONFIRM_TYPES,
  DEFAULT_ROW_PER_PAGE,
  DEFAULT_HOMEPAGE_ROW_PER_PAGE,
  ROW_PER_PAGE_OPTIONS,
  SIM_TYPE_LIST,
  SIM_TYPE_LIST_OBJ,
} from 'src/utils/constants';
import { getSimsoStatus } from 'src/utils/utils';
import {
  Box,
  Card,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  IconButton,
} from '@material-ui/core';

import { Outlet, Link, useNavigate, useLocation } from "react-router-dom";

import numeral from 'numeral';

import iconMobifone from "../../assets/images/operators/mobifone.jpg";
import iconVinaphone from "../../assets/images/operators/vinaphone.jpg";
import iconViettel from "../../assets/images/operators/viettel.png";
import logoNhaMang from "../../assets/images/logo_mang_1.svg";

const TheHomepageSimsoDetail = ({ ...rest }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const currentPage = queryParams.get("page");
  const [selectedSimsoIds, setSelectedSimsoIds] = useState([]);
  const [homepageSimsoLimit, setLimit] = useState(DEFAULT_HOMEPAGE_ROW_PER_PAGE);
  const [homepageSimsoPage, setPage] = useState(currentPage ? parseInt(currentPage) - 1 : 0);
  const { homepageSimsoItems, homepageSimsoTotal, homepageSimsoFilter } = useSelector(state => state.simso);
  const [confirm, setConfirm] = useState(false);
  const [confirmType, setConfirmType] = useState("");
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [selected, setSelected] = useState({});
  const [open, setOpen] = useState(false);
  const { info, permissions, role } = useSelector(state => state.profile)
  const { isLoading } = useSelector(state => state.app);
  
  useEffect(() => {
    setPage(currentPage ? parseInt(currentPage - 1): 0);
  }, [currentPage])

  useEffect(() => {
    const payload = {
      ...homepageSimsoFilter,
      homepageSimsoLimit: homepageSimsoLimit,
      homepageSimsoPage: homepageSimsoPage,
    };
    dispatch(SimsoAction.updateHomepageFilter(payload));
    dispatch(SimsoAction.homepageList())
  }, [homepageSimsoPage, homepageSimsoLimit])

  const handleSelectAll = (event) => {
    let newSelectedSimsoIds;

    if (event.target.checked) {
      newSelectedSimsoIds = homepageSimsoItems.map((simso) => simso.id);
    } else {
      newSelectedSimsoIds = [];
    }

    setSelectedSimsoIds(newSelectedSimsoIds);
  };

  const handleSelectOne = (event, id) => {
    const selectedIndex = selectedSimsoIds.indexOf(id);
    let newSelectedSimsoIds = [];

    if (selectedIndex === -1) {
      newSelectedSimsoIds = newSelectedSimsoIds.concat(selectedSimsoIds, id);
    } else if (selectedIndex === 0) {
      newSelectedSimsoIds = newSelectedSimsoIds.concat(selectedSimsoIds.slice(1));
    } else if (selectedIndex === selectedSimsoIds.length - 1) {
      newSelectedSimsoIds = newSelectedSimsoIds.concat(selectedSimsoIds.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelectedSimsoIds = newSelectedSimsoIds.concat(
        selectedSimsoIds.slice(0, selectedIndex),
        selectedSimsoIds.slice(selectedIndex + 1)
      );
    }

    setSelectedSimsoIds(newSelectedSimsoIds);
  };

  const handleLimitChange = (event) => {
    setLimit(event.target.value);
    setPage(0);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);

    // Gán giá trị mặc định
    queryParams.set("page", newPage + 1);

    // Cập nhật URL mà không reload trang
    navigate({
      pathname: location.pathname,
      search: `?${queryParams.toString()}`
    }, { replace: true }); // replace để không thêm vào lịch sử trình duyệt
  };

  const handleConfirmOpen = (type, simso) => {
    setSelected(simso);
    setConfirmType(type);
    if (confirmType === CONFIRM_TYPES.DELETE) {
      setTitle("Xoá bản ghi")
      setContent(`Xác nhận xoá bản ghi `)
    }
    setConfirm(true);
  };

  const onConfirm = () => {
    setConfirm(false);
    if (confirmType === CONFIRM_TYPES.DELETE) {
      dispatch(SimsoAction.del(selected.id))
      return;
    }
  }

  const handleConfirmClose = () => {
    setConfirm(false);
  };

  const onSelected = (id) => {
    dispatch(SimsoAction.findOne(id));
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const totalPages = Math.ceil(homepageSimsoTotal / homepageSimsoLimit);
  
  const renderPagination = () => {
      const pages = [];
      const maxPagesToShow = 5;
      
      if (totalPages <= maxPagesToShow) {
          for (let i = 0; i < totalPages; i++) {
              pages.push(i);
          }
      } else {
          if (homepageSimsoPage > 2) pages.push(0, "...");
          for (let i = Math.max(0, homepageSimsoPage - 2); i <= Math.min(totalPages - 1, homepageSimsoPage + 2); i++) {
              pages.push(i);
          }
          if (homepageSimsoPage < totalPages - 3) pages.push("...", totalPages - 1);
      }
      
      return pages.map((page, index) => (
          <button className={`page-btn ${typeof page === "number" ? (currentPage && parseInt(currentPage) == page + 1 || !currentPage && page == 0 ? "current-selected" : "") : "not-number"}`} key={index} onClick={(e) => typeof page === "number" && handlePageChange(e, page)}
              disabled={page === homepageSimsoPage || page === "..."} style={{
                  padding: "8px 12px", background: page === homepageSimsoPage ? "var(--main-color)" : "var(--main-color)", color: "#fff",
                  border: "none", borderRadius: "5px", cursor: page === homepageSimsoPage || page === "..." ? "default" : "pointer",
                  margin: "0", transition: "0.3s"
              }}>
              {page === "..." ? "..." : page + 1}
          </button>
      ));
  };

  const renderPhoneNumber = (phoneNumber) => {
      const searchPhone = homepageSimsoFilter?.so_dien_thoai?.replace(/[^\d*]/g, "") || "";
      const cleanPhone = phoneNumber.replace(/[^\d]/g, "");

      if (!searchPhone) {
          return renderChars(phoneNumber, []);
      }

      let matchIndices = [];

      const parts = searchPhone.split("*").filter((p) => p !== "");
      const stars = (searchPhone.match(/\*/g) || []).length;

      if (!searchPhone.includes("*")) {
          // Trường hợp chứa chuỗi
          const idx = cleanPhone.indexOf(searchPhone);
          if (idx !== -1) {
              for (let i = 0; i < searchPhone.length; i++) {
                  matchIndices.push(idx + i);
              }
          }
      } else if (stars === 1 && parts.length === 2 && !searchPhone.startsWith("*") && !searchPhone.endsWith("*")) {
          // 1 dấu *, ví dụ 090*1 → bắt đầu = 090, kết thúc = 1
          const [start, end] = parts;
          if (cleanPhone.startsWith(start) && cleanPhone.endsWith(end)) {
              for (let i = 0; i < start.length; i++) matchIndices.push(i);
              for (let i = cleanPhone.length - end.length; i < cleanPhone.length; i++) matchIndices.push(i);
          }
      } else if (searchPhone.endsWith("*") && parts.length === 1) {
          // Bắt đầu bằng chuỗi
          const [start] = parts;
          if (cleanPhone.startsWith(start)) {
              for (let i = 0; i < start.length; i++) matchIndices.push(i);
          }
      } else if (searchPhone.startsWith("*") && parts.length === 1) {
          // Kết thúc bằng chuỗi
          const [end] = parts;
          if (cleanPhone.endsWith(end)) {
              for (let i = cleanPhone.length - end.length; i < cleanPhone.length; i++) matchIndices.push(i);
          }
      } else if (stars >= 2 && parts.length >= 2) {
          // Trường hợp có ≥ 2 dấu *
          const start = parts[0];
          const end = parts[parts.length - 1];
          const middles = parts.slice(1, -1);

          if (cleanPhone.startsWith(start) && cleanPhone.endsWith(end)) {
              for (let i = 0; i < start.length; i++) matchIndices.push(i);
              for (let i = cleanPhone.length - end.length; i < cleanPhone.length; i++) matchIndices.push(i);

              // Tìm từng middle theo thứ tự, sau khi start
              let lastIndex = start.length;
              middles.forEach((middle) => {
                  const idx = cleanPhone.indexOf(middle, lastIndex);
                  if (idx !== -1) {
                      for (let i = 0; i < middle.length; i++) {
                          matchIndices.push(idx + i);
                      }
                      lastIndex = idx + middle.length;
                  }
              });
          }
      }

      return renderChars(phoneNumber, matchIndices);
  };

  // Đánh dấu các ký tự được highlight
  function renderChars(phoneNumber, matchIndices) {
      let digitIndex = 0;
      return [...phoneNumber].map((char, i) => {
          if (/\d/.test(char)) {
              const highlight = matchIndices.includes(digitIndex);
              const className = `number-char${highlight ? " number-highlight" : ""}`;
              digitIndex++;
              return (
                  <span className={className} key={i}>
                      {char}
                  </span>
              );
          } else {
              return (
                  <span className="dot-char" key={i}>
                      {char}
                  </span>
              );
          }
      });
  }

  // Escape ký tự đặc biệt trong regex
  function escapeRegExp(string) {
      return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }

  return (
    <>
        {isLoading && <div className='loading'></div>}
        
        {!isLoading && <div className='sim-list-show' style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "10px" }}>
            {homepageSimsoItems && homepageSimsoItems.slice(homepageSimsoPage * homepageSimsoLimit, homepageSimsoPage * homepageSimsoLimit + homepageSimsoLimit).map((simso, index) => (
                simso ? <Link to={`/trang-chu/sim-so/${simso.so_dien_thoai}`} className="sim-item simvip" onMouseEnter={e => e.currentTarget.style.border = "1px solid var(--main-color)"} onMouseLeave={e => e.currentTarget.style.border = "1px solid #ddd"} style={{ display: "flex", alignItems: "center", gap: "10px", padding: "10px", border: "1px solid #ddd", borderRadius: "5px", boxShadow: "0px 2px 5px rgba(0,0,0,0.2)", background: "#fff", textDecoration: "none", color: "inherit" }}>
                    <img className='operator-icon' src={simso.nha_mang == "MOBIFONE" ? iconMobifone : (simso.nha_mang == "VINAPHONE" ? iconVinaphone : iconViettel)} alt={`Sim số đẹp ${simso.so_dien_thoai_co_dau_cham}`} />
                    {/* <div className='operator-icon' style={{
                        backgroundImage: `url(${logoNhaMang})`,
                        backgroundRepeat: "no-repeat",
                        display: "inline-block",
                    }}></div> */}
                    <div style={{width: "calc(100%)"}}>
                        <div className="sim">{renderPhoneNumber(simso.so_dien_thoai_co_dau_cham)}</div>
                        <div className="price">
                          {(Number(simso.gia_khach_hang_khuyen_mai) > 0 && Number(simso.gia_khach_hang_khuyen_mai) < Number(simso.gia_khach_hang)) ? (
                            <div>
                              <span style={{ color: 'red', fontWeight: 'bold' }}>
                                {numeral(simso.gia_khach_hang_khuyen_mai).format('0,0')}₫
                              </span>
                              <br></br>
                              <span className='price-old' style={{ textDecoration: 'line-through', color: '#888' }}>
                                {numeral(simso.gia_khach_hang).format('0,0')}₫
                              </span>
                            </div>
                          ) : (
                            <div>
                              <span style={{ fontWeight: 'bold' }}>
                                {numeral(simso.gia_khach_hang).format('0,0')}₫
                              </span>
                            </div>
                          )}
                        </div>
                    </div>
                </Link> : null
            ))}
        </div>}

        {!isLoading && <div className='list-pagination' style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: "20px", gap: "5px" }}>
            <button onClick={(e) => handlePageChange(e, homepageSimsoPage - 1)} disabled={homepageSimsoPage === 0} style={{ padding: "10px 15px", background: "var(--main-color)", color: "#fff", border: "none", borderRadius: "5px", cursor: "pointer", transition: "0.3s" }}
            onMouseEnter={e => e.target.style.background = "var(--main-color)"}
            onMouseLeave={e => e.target.style.background = "var(--main-color)"}>
                {"<"}
            </button>
            {renderPagination()}
            <button onClick={(e) => handlePageChange(e, homepageSimsoPage + 1)} disabled={homepageSimsoPage + 1 >= homepageSimsoTotal / homepageSimsoLimit} style={{ padding: "10px 15px", background: "var(--main-color)", color: "#fff", border: "none", borderRadius: "5px", cursor: "pointer", transition: "0.3s" }}
            onMouseEnter={e => e.target.style.background = "var(--main-color)"}
            onMouseLeave={e => e.target.style.background = "var(--main-color)"}>
                {">"}
            </button>
        </div>}
    </>
  );
};

export default TheHomepageSimsoDetail;
